import store from "app/redux/store/store";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";


import {atualizarItemAction, criarOrcamentoAction as criarOrcamentoAction} from  'app/redux/orcamentoSlice'
import { verificacaoContinuaIgualdadeEstados } from "app/utils/verificacaoContinuaIgualdadeEstados";
import { popularPropriedadesNovoItem } from "./popularPropriedadesNovoItem";
import { corrigirDatasOrcamento } from "./corrigirDatasOrcamento";
import { corrigirDatasItemOrcamento } from "./corrigirDatasItemOrcamento";
import { obterAmbientesPelosItens } from "./ambiente/obterAmbientesPelosItens";
import * as R from "ramda";
import { coresAmbientes } from "./ambiente/coresAmbientes";
import { associarCorAction } from "app/redux/corPorAmbienteSlice";
import globalMU from "globalMU";
import microuniversoApi from "app/api/microuniversoApi";

export async function criarOrcamento(orcamento: IOrcamento) {
    
    const valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL = await microuniversoApi.Parametro.obter("ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL")

    store.dispatch(criarOrcamentoAction({
        ...(corrigirDatasOrcamento(orcamento)),
        AtualizarDescontos: false,
        AtualizarTotais: false,
        AtualizarItens: false,
        AtualizarParcelas: false,
        AtualizarRemoto: true,
        VerificarPendenciaFormaDePagamento: false,
        VerificarPendenciaVendaFrete: false,
        CalcularFreteAutomaticamente: false,
        RecalcularPrecos: orcamento?.RecalcularPrecos ?? true, // 419846 padrao será não recalcular
        ItensOrcamento: (orcamento?.ItensOrcamento ?? [])
            .map(item => popularPropriedadesNovoItem({
                item,
                corPorAmbiente: store.getState().corPorAmbiente,
                informacoesOrcamento: orcamento,
                valorParametro_ORCAMENTO_OUTRAS_SAIDAS_RETIRADA_OUTRO_LOCAL}))
            .map(corrigirDatasItemOrcamento)
    }))

    const ambientes = R.pipe(obterAmbientesPelosItens, R.uniqBy(a => a.nome))()

    R.zip(ambientes,coresAmbientes).forEach(pair => store.dispatch(associarCorAction({
        ambiente: pair[0].nome,
        cor: pair[1]
    })))

    store.getState().orcamento?.ItensOrcamento.forEach(i => store.dispatch(atualizarItemAction({
        identificador: i.Identificador,
        dados: {
            CorAmbiente: globalMU.isNotNullOrEmpty(i.Ambiente) ? store.getState().corPorAmbiente[i.Ambiente] : null
        }})))

    //verificacaoContinuaIgualdadeEstados()

}

